import React, { Component } from 'react'
import { AlphanumericInputWithMask } from '@lmig/lmds-react'

class Phone extends Component {
  state = {
    ht: 'error',
    val: undefined,
  }
  handleFormChange = event => {
    let inputValue = event.target.value
    if (inputValue.length > 0) {
      this.setState({ ht: undefined })
    } else {
      this.setState({ ht: 'error' })
    }
  }
  render() {
    const { onChangeValue } = this.props
    return (
      <AlphanumericInputWithMask
        highlightType={this.state.ht}
        name='phoneNumber'
        id='Alphanumeric--error'
        labelVisual='Phone Number'
        type='tel'
        mask='phone'
        onChange={function (e) {
          onChangeValue(e)
          this.handleFormChange(e)
        }.bind(this)}
      />
    )
  }
}

export default Phone
